import { defineComponent as _defineComponent } from 'vue'
import { dir } from 'bits/current_dir'
import { __ } from 'bits/intl'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzIconButton, { OzIconButtonColorScheme, OzIconButtonSizePreset } from 'library/v4/components/OzIconButton.vue'
import OzPadletLogo, { OzPadletLogoColorScheme, OzPadletLogoSizePreset } from 'library/v4/components/OzPadletLogo.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from 'library/v4/components/OzPlainButton.vue'
import { storeToRefs } from 'pinia'
import { useDarkModeStore } from 'pinia/dark_mode'
import { useLandsideNavigationStore } from 'pinia/landside_navigation'
import { useWindowSizeStore } from 'pinia/window_size'
import { computed, ref } from 'vue'
import LandsideFooterSection, { LandsideNavigation } from 'vuecomponents/LandsideFooterSection.vue'
import LocaleSelector from 'vuecomponents/LocaleSelector.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandsideFooter',
  setup(__props) {

const { isSmallerThanDesktop, windowWidth } = storeToRefs(useWindowSizeStore())
const { isDarkMode } = storeToRefs(useDarkModeStore())
const { landsidePages } = storeToRefs(useLandsideNavigationStore())

const socialMediaIcons = [
  { icon: 'youtube_outline', url: 'https://www.youtube.com/@padlet', label: 'Youtube' },
  { icon: 'twitter_outline', url: 'https://twitter.com/padlet', label: 'Twitter' },
  { icon: 'facebook_outline', url: 'https://www.facebook.com/padlet/', label: 'Facebook' },
  { icon: 'instagram_outline', url: 'https://www.instagram.com/padlet', label: 'Instagram' },
  { icon: 'linkedin_outline', url: 'https://www.linkedin.com/company/padlet', label: 'Linkedin' },
]

const productNavigationItems: LandsideNavigation[] = [
  { name: __('Features'), url: 'https://www.padlet.com/site/product' },
  { name: __('Apps and Integration'), url: 'https://www.padlet.com/about/apps' },
  { name: __('What’s new'), url: 'https://padlet.blog/' },
]

const membershipsNavigationItems: LandsideNavigation[] = [
  { name: __('Personal'), url: 'https://www.padlet.com/memberships#personal' },
  { name: __('Teams'), url: 'https://www.padlet.com/memberships#team' },
  { name: __('Schools'), url: 'https://www.padlet.com/memberships#school' },
]

const companyNavigationItems: LandsideNavigation[] = [
  { name: __('About us'), url: 'https://www.padlet.com/about/us' },
  { name: __('Jobs'), url: 'https://www.angel.co/company/padlet/jobs' },
  { name: __('Twitter'), url: 'https://www.twitter.com/padlet' },
]

const supportNavigationItems: LandsideNavigation[] = [
  { name: __('Knowledge'), url: 'https://www.padlet.help' },
  { name: __('Video tutorials'), url: 'https://www.youtube.com/padlet' },
  { name: __('Examples'), url: 'https://www.padlet.com/gallery' },
  { name: __('Contact us'), url: 'https://www.padlet.com/contact-us' },
]

const legalNavigationItems: LandsideNavigation[] = [
  { name: __('Terms of use'), url: 'https://legal.padlet.com/terms' },
  { name: __('Privacy policy'), url: 'https://legal.padlet.com/privacy' },
  { name: __('Content policy'), url: 'https://legal.padlet.com/content' },
  { name: __('Accessibility statement'), url: 'https://legal.padlet.com/accessibility' },
]

const footerIllustrationDarkUrl = 'https://padlet.net/homepage/v4/footer_illustration_dark.webp'
const footerIllustrationLightUrl = 'https://padlet.net/homepage/v4/footer_illustration_light.webp'
const ILLUSTRATION_ORIGINAL_IMAGE_WIDTH = 11520
const ILLUSTRATION_ORIGINAL_IMAGE_HEIGHT = 1152
const illustrationContainer = ref<HTMLDivElement>()

// We use maxAvailableWidth to handle the case when users zoom in/out which causes
// the windowWidth to change
const maxAvailableWidth = computed((): number => {
  if (!illustrationContainer.value) return windowWidth.value
  return Math.max(illustrationContainer.value.clientWidth, windowWidth.value)
})

const illustrationHeight = computed((): number => {
  if (isSmallerThanDesktop.value) return 80
  return 138
})

const illustrationWidth = computed((): number => {
  // We calculate the width of the illustration using the ratio (width / height) of the original image
  return illustrationHeight.value * (ILLUSTRATION_ORIGINAL_IMAGE_WIDTH / ILLUSTRATION_ORIGINAL_IMAGE_HEIGHT)
})

const numberOfIllustrationsDisplayed = computed((): number => {
  if (maxAvailableWidth.value < illustrationWidth.value) return 1
  return Math.ceil(maxAvailableWidth.value / illustrationWidth.value)
})

const lastIllustrationWidth = computed((): number => {
  const remainingWidth = maxAvailableWidth.value - (numberOfIllustrationsDisplayed.value - 1) * illustrationWidth.value
  return remainingWidth === 0 ? illustrationWidth.value : remainingWidth
})

function handleObjectPosition(shouldReverse: boolean): string {
  if (shouldReverse) {
    // For rtl, we need to position the object from the left
    if (dir === 'ltr') return 'right'
    return 'left'
  }
  if (dir === 'ltr') return 'left'
  return 'right'
}

return { __sfc: true,isSmallerThanDesktop, windowWidth, isDarkMode, landsidePages, socialMediaIcons, productNavigationItems, membershipsNavigationItems, companyNavigationItems, supportNavigationItems, legalNavigationItems, footerIllustrationDarkUrl, footerIllustrationLightUrl, ILLUSTRATION_ORIGINAL_IMAGE_WIDTH, ILLUSTRATION_ORIGINAL_IMAGE_HEIGHT, illustrationContainer, maxAvailableWidth, illustrationHeight, illustrationWidth, numberOfIllustrationsDisplayed, lastIllustrationWidth, handleObjectPosition, __, ImageThumbnail, OzIcon, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzPadletLogo, OzPadletLogoColorScheme, OzPadletLogoSizePreset, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset, LandsideFooterSection, LocaleSelector }
}

})